import { URL_SUBSCRIPTION_TYPE } from './ROUTES';

export const URLS_EPARGNE = {
  SIRET: URL_SUBSCRIPTION_TYPE.EPARGNE + '/siret',
  ENTREPRISE_INFORMATION: URL_SUBSCRIPTION_TYPE.EPARGNE + '/informations',
  IDENTITE: URL_SUBSCRIPTION_TYPE.EPARGNE + '/representant',
  DISPOSITIF_ACTUEL: URL_SUBSCRIPTION_TYPE.EPARGNE + '/dispositif-actuel',
  INTERESSEMENT: URL_SUBSCRIPTION_TYPE.EPARGNE + '/interessement',
  PARTICIPATION: URL_SUBSCRIPTION_TYPE.EPARGNE + '/participation',
  DISPOSITIF_ABONDEMENT: URL_SUBSCRIPTION_TYPE.EPARGNE + '/abondement',
  KYC: URL_SUBSCRIPTION_TYPE.EPARGNE + '/kyc',
  TARIFICATION: URL_SUBSCRIPTION_TYPE.EPARGNE + '/tarification',
  FINALISATION: URL_SUBSCRIPTION_TYPE.EPARGNE + '/finalisation'
};

export const ETAPES_DOSSIER_EPARGNE = {
  SIRET: 0,
  ENTREPRISE_INFORMATION: 1,
  IDENTITE: 2,
  DISPOSITIF_ACTUEL: 3,
  INTERESSEMENT: 4,
  PARTICIPATION: 5,
  DISPOSITIF_ABONDEMENT: 6,
  KYC: 7,
  TARIFICATION: 8,
  EN_ATTENTE_DE_SIGNATURE: 8,
  INFORMATIONS: 9,
  TRANSMIS: 10
};

export const SECTIONS_EPARGNE = {
  ENTREPRISE: {
    URL: URLS_EPARGNE.ENTREPRISE_INFORMATION,
    INDEX: 0,
    ETAPE: ETAPES_DOSSIER_EPARGNE.ENTREPRISE_INFORMATION
  },
  BESOIN: {
    URL: URLS_EPARGNE.DISPOSITIF_ACTUEL,
    INDEX: 1,
    ETAPE: ETAPES_DOSSIER_EPARGNE.DISPOSITIF_ACTUEL
  },
  ADHESION: {
    URL: URLS_EPARGNE.TARIFICATION,
    INDEX: 2,
    ETAPE: ETAPES_DOSSIER_EPARGNE.TARIFICATION
  }
};
